import React, { Component } from 'react';
import PropTypes from 'prop-types';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
import { Mutation } from 'components/common/Query';
// our componentsM
import Notes from './Notes';

export const ADD_NOTE_MUTATION = gql`
  mutation(
    $objectId: Int!
    $entity: AdminAddNoteFormEntity!
    $description: String!
  ) {
    addNote(
      input: { objectId: $objectId, description: $description, entity: $entity }
    ) {
      note {
        id
        createdOn
        description
        creator
      }
      errors {
        field
        messages
      }
      clientMutationId
    }
  }
`;

export const REMOVE_NOTE_MUTATION = gql`
  mutation($id: ID) {
    deleteNote(input: { id: $id }) {
      id
      errors {
        field
        messages
      }
      clientMutationId
    }
  }
`;

class NotesContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notes: props.allNotes || [],
      errors: [],
    };
    this.Compose = adopt({
      addNote: this.handleAddNote,
      removeNote: this.handleRemoveNote,
    });
  }

  /**
   * @description
   * Callback for add note
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  handleAddNote = ({ render }) => (
    <Mutation
      mutation={ADD_NOTE_MUTATION}
      onCompleted={this.handleAddNoteCompleted}
    >
      {(handleAdd, { loading }) => render({ handleAdd, loadingAdd: loading })}
    </Mutation>
  );

  /**
   * @description
   * OnComplete add mutation.
   * @param {*} data - Mutation result.
   */
  handleAddNoteCompleted = async ({ addNote }) => {
    const { notes } = this.state;
    const { note, errors } = addNote;

    if (errors) {
      this.setState({ errors });
    } else {
      this.setState({ notes: [note, ...notes] });
    }
  };

  /**
   * @description
   * Callback for delete note.
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  handleRemoveNote = ({ render }) => (
    <Mutation
      mutation={REMOVE_NOTE_MUTATION}
      onCompleted={this.handleRemoveNoteCompleted}
    >
      {(handleRemove, { loading }) =>
        render({ handleRemove, loadingRemove: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * OnComplete delete mutation.
   * @param {*} deleteNote - Mutation result.
   * @returns {*} Mutation result.
   */
  handleRemoveNoteCompleted = async ({ deleteNote }) => {
    const { notes } = this.state;
    const { id, errors } = deleteNote;

    if (errors) {
      this.setState({ errors });
    } else {
      const oldNotes = notes.filter(note => note.id !== id);
      this.setState({ notes: oldNotes });
    }
  };

  render() {
    const { entityID, entity } = this.props;
    const { notes, errors } = this.state;
    return (
      <this.Compose>
        {({
          addNote: { handleAdd, loadingAdd },
          removeNote: { handleRemove, loadingRemove },
        }) => (
          <Notes
            data={notes}
            addNote={note =>
              handleAdd({
                variables: {
                  objectId: entityID,
                  description: note,
                  entity,
                },
              })
            }
            isSaving={loadingAdd}
            removeNote={noteID => handleRemove({ variables: { id: noteID } })}
            isRemovingNote={loadingRemove}
            errors={errors}
            showNotification={errors.length > 0}
            closeNotification={() => this.setState({ errors: [] })}
          />
        )}
      </this.Compose>
    );
  }
}

NotesContainer.propTypes = {
  entityID: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  entity: PropTypes.instanceOf(PropTypes.string).isRequired,
  allNotes: PropTypes.instanceOf(Array).isRequired,
};

export default NotesContainer;
